import React from 'react'
import { useSelector } from 'react-redux'

import '../styles/ProfileForm.scss'

import { ApplicationState } from 'AppReducer'

import ProfileForm from './components/ProfileForm'
import ContactForm from '../contact/ContactForm'
import ContactList from '../contact/ContactList'
import AddressForm from '../address/AddressForm'
import AddressList from '../address/AddressList'
import DocumentList from '../document/DocumentList'
import DocumentForm from '../document/DocumentForm'
import UpdatePassword from './components/UpdatePassword'

const UserProfile: React.FC = () => {
  const { logged } = useSelector((state: ApplicationState) => state.userReducer)
  return (
    <div className="row">
      <div className="row padding-left-8">
        <h1 className="col-12">Meus Dados</h1>
        <p className="col-12">Mantenha suas informações de perfil sempre atualizadas</p>
      </div>

      <ProfileForm />
      <UpdatePassword />

      <div className="row panel margin-top-16 form-responsive">
        <ContactForm person={logged?.person.id} />
        <ContactList person={logged?.person.id} />
      </div>

      <div className="row panel margin-top-16">
        <DocumentForm person={logged?.person.id} />
        <DocumentList person={logged?.person.id} />
      </div>

      <div className="row panel margin-top-16">
        <AddressForm person={logged?.person.id} />
        <AddressList person={logged?.person.id} />
      </div>

    </div>
  )
}

export default UserProfile
